import React, { useState, useEffect } from "react";
import { map, distinctUntilChanged } from "rxjs/operators";

function getState(states, stateRef) {
  function getStateName(statesInner, refIds) {
    let state = statesInner.get(refIds.get(0));
    console.log("stateTrees getStateName " + statesInner + refIds);
    let label = "->" + state.get("name");
    if (refIds.size > 1 && state.get("children"))
      label =
        label +
        getStateName(state.get("children"), refIds.slice(1, refIds.size));
    return label;
  }
  let state = states.get(stateRef.get(0));
  let label = state.get("name");
  console.log("stateTrees getState " + state.get("type"));
  if (stateRef.size > 1 && state.get("type").get("children"))
    label =
      label +
      getStateName(
        state.get("type").get("children"),
        stateRef.slice(1, stateRef.size)
      );
  return <span>{label}</span>;
}

const CompAttrView = ({ attr, superType, attrValue, states }) => {
  let attrType = attr.get("type");
  let nameClass;
  switch (superType) {
    case "view":
      nameClass = "ViewTitle";
      break;
    case "ui-binding":
      nameClass = "UiBinding";
      break;
    case "ui-action":
      nameClass = "UiAction";
      break;
    case "ui-single-reaction":
      nameClass = "UiSingleActionTitle";
      break;
    default:
      nameClass = "";
  }
  if (attrType === "name") return <div className={nameClass}>{attrValue}</div>;
  else if (attrType === "label")
    return <div className="Labell">{attrValue}</div>;
  else if (attrType === "state") {
    return <div className="UiStateRef">{getState(states, attrValue)}</div>;
  } else if (attrType === "select") {
    let values = attr.get("selectValues");
    function findSelectLabel() {
      let found = "NONE";
      values.forEach(val => {
        if (val.get("value") === attrValue) found = val.get("label");
      });
      return found;
    }
    return (
      <div>
        {attr.get("name")}: {findSelectLabel()}
      </div>
    );
  } else if (attrType === "ui-event") {
    let valueText = <div>Ui-Event: {attrValue}</div>;
    /*if (
      props.attrValue &&
      this.state.uiEvents &&
      this.state.uiEvents.get(parseInt(props.attrValue))
    ) {
      valueText = this.state.uiEvents.get(parseInt(props.attrValue)).get("name");
    }*/
    return <div>{valueText}</div>;
  } else if (attrType === "text") return <div>{attrValue}</div>;
  else if (attrType === "number") return <div>{attrValue}</div>;
  else if (attrType === "boolean") return <div>{attrValue}</div>;
  return "";
};

function getUiEvent(value) {
  let valueText = "";
  if (
    value &&
    this.state.uiEvents &&
    this.state.uiEvents.get(parseInt(value))
  ) {
    valueText = this.state.uiEvents.get(parseInt(value)).get("name");
  }
  return <div>{valueText}</div>;
}
export default CompAttrView;



// WEBPACK FOOTER //
// ./src/components/CompAttrView.js